import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入语言包
import zh from '@/assets/i18n/zh' // 中文语言包
import en from '@/assets/i18n/en'
import ja from '@/assets/i18n/ja'

Vue.use(VueI18n) // 英文语言包

const messages = {
  zh: zh, // 中文语言包
  en: en, // 英文语言包
  ja: ja,
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale: 'en', // set locale 默认显示英文
  messages: messages, // set locale messages
})
